import React from "react";

import { Grid } from "@mui/material";
import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { GoContainer } from "react-icons/go";

import { CartonView } from "../../../../../../models/carton";
import { ShipmentType } from "../../../../../../util/enums";
import { useShipmentContext } from "../../../../../Shipments/hooks/useShipmentContext";
import { DefaultTooltip } from "../../../../Tooltip";
import useStyles from "../../../styles";
import { ContainerModalHandles } from "../../AddContainerModal";

interface Props {
  carton?: CartonView;
  show?: boolean;
  containerRef: React.RefObject<ContainerModalHandles>;
}

const ContainerButton = (props: Props) => {
  const { shipment } = useShipmentContext();
  const { carton, show, containerRef } = props;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (!carton || !show || shipment?.shipmentType !== ShipmentType.SEA) return null;

  const onClick = () => containerRef.current?.open([carton?.sscc], carton?.container);

  return (
    <Grid item data-cy="container-sscc" className={classes.roundButton}>
      <DefaultTooltip title={translate("addInAContainer")}>
        <div className={classes.printButton} onClick={onClick}>
          <GoContainer
            size={GridConstants.defaultRowActionSize}
            color={GridConstants.defaultColorIcon}
          />
        </div>
      </DefaultTooltip>
    </Grid>
  );
};

export default ContainerButton;
